// src/pages/driver/driverJobList/InlineJobNotes.jsx — self-contained driver-note editor for
// a single job, loads/saves directly to Firestore.
import { useEffect, useState } from "react";
import { db } from "../../../services/firebase";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

export default function InlineJobNotes({ jobId }) {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "jobs", jobId));
        if (on && snap.exists()) {
          const d = snap.data() || {};
          setValue(d.driverNotes ?? "");
        }
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => {
      on = false;
    };
  }, [jobId]);

  async function save() {
    if (!dirty) return;
    setSaving(true);
    try {
      await updateDoc(doc(db, "jobs", jobId), {
        driverNotes: value || "",
        driverNotesUpdatedAt: serverTimestamp(),
      });
      setDirty(false);
    } finally {
      setSaving(false);
    }
  }

  if (!jobId) return null;

  return (
    <div className="mt-3">
      <label className="block text-xs font-medium text-gray-700 mb-1">
        Driver note to office
      </label>
      <textarea
        rows={3}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-emerald-400 focus:border-emerald-400"
        placeholder="Type anything you want the office to know..."
        disabled={loading}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setDirty(true);
        }}
      />
      <div className="mt-2 flex items-center gap-2">
        <button
          onClick={save}
          disabled={loading || saving || !dirty}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition ${
            loading || saving || !dirty
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : "bg-gray-900 text-white hover:bg-black"
          }`}
        >
          {saving ? "Saving..." : "Save notes"}
        </button>
        {!dirty && !saving && !loading && (
          <span className="text-xs text-gray-500">Saved</span>
        )}
      </div>
    </div>
  );
}
